<template>
  <div class="page page-feedback" v-if="showPage">
    <navigation>反馈评价</navigation>

    <div class="feedback-main">
      <form ref="form">
        <div class="feedback-section feedback-voucher">
          <div class="voucher-title">
            反馈内容
          </div>
          <div class="voucher-content">
            <div class="form-item">
              <nd-input
                name="content"
                type="textarea"
                class="textarea"
                v-model="form.content"
                label=""
                :rows="5"
                :autoSize="false"
                maxLength="200"
                placeholder="请输入您的问题"
              ></nd-input>
            </div>
          </div>
        </div>

        <div class="feedback-section feedback-voucher">
          <div class="voucher-title no-title-required">
            问题截图（选填）
          </div>
          <div class="voucher-content">
            <div class="form-item">
              <nd-upload
                name="imageUrls"
                :images.sync="form.imageUrls"
                fileType="FEEDBACK"
                :limit="5"
              ></nd-upload>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="feedback-bottom">
      <nd-button @click="handleApply" :isDisabled="isDisabled" :loading="pending">提交反馈</nd-button>
    </div>

  </div>
</template>

<script>
import validate from '@/components/nd-validate/validateNew'
import { mapActions } from 'vuex'
import wx from 'weixin-webview-jssdk'
import { isTMDMiniprogram } from '@/assets/utils'
export default {
  mixins: [validate],
  data () {
    return {
      step: 1,
      isDisabled: true,
      pending: false,
      showPage: false,
      form: {
        content: '',
        imageUrls: [] 
      },
      rules: {
        content: [
          { require: true, message: '反馈内容不能为空', trigger: 'blur' },
          {
            handler: (input) => input.length >= 5,
            message: '反馈内容至少输入 5 个字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    if (localStorage.getItem('feedbackDate') === this.formatDate(new Date())) {
      this.$router.push('/feedback/result')
    } else {
      this.showPage = true
    }
    this.$bus.$emit('ready')
  },
  mounted () {
    const ref = this.$refs.form
    if (ref) {
      this.validator(ref, this.rules)
    }
  },
  methods: {
    ...mapActions('user', ['feedbackEvaluate']),

    async handleApply () {
      const ref = this.$refs.form
      if (ref) {
        const res = this.validate(ref, this.rules)
        if (!res) return
        if (this.pending) return
        this.pending = true
        const { success } = await this.feedbackEvaluate(this.form)
        if (success) {
          this.$message('反馈成功')
          setTimeout(() => {
            if (isTMDMiniprogram()) {
              wx.miniProgram.navigateBack()
              return 
            }
            this.back()
          }, 2000)
        } else {
          this.pending = false
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-feedback {
  background: #FAFAFA;
  padding-bottom: 270px;
  .tpis {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
  }
  .feedback-main {
    padding: 40px;
    .feedback-section {
      border-radius: 20px;
      margin-top: 50px;
      .voucher-title {
        font-weight: 500;
        font-size: 28px;
        color: #666;
        font-family: PingFangSC, PingFang SC;
        &::before {
          content: "*";
          color: #ff5223;
        }
        &.no-title-required::before {
          content: "";
        }
      }
      .nd-input {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eee;
      }
      .form-item {
        padding-top: 8px;
        .textarea {
          padding: 12px;
          border-bottom: none;
          height: 220px !important;
          background: #fff;
          border-radius: 16px;
          textarea {
            height: 220px !important;
          }
        }
      }
      &.section-progress {
        padding: 70px 60px 37px;
      }
      &.feedback-info {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #333333;
        padding: 57px 0 66px;
        .info-title {
          font-size: 24px;
        }
        .info-amount {
          font-family: DIN-Medium, DIN;
          font-size: 48px;
          font-weight: 500;
          margin-top: 7px;
          span {
            font-size: 72px;
          }
        }
      }
    }

    .feedback-desc {
      margin-top: 30px;
      .desc-title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
      }
      .desc-content {
        font-size: 24px;
        color: #999999;
        margin-top: 8px;
        line-height: 33px;
      }
    }
  }
  .feedback-bottom {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    width: 750px;
    left: auto;
    right: auto;
    padding: 28px 50px 58px;
    .bottom-btn {
      width: 100%;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      color: #fff;
      font-size: 32px;
    }
  }
}
</style>